import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import ReviewCard from "./ReviewCard";
import restaurantContext from "./context/restaurantContext";
import RestaurantCard from "../src/RestaurantCard";

const RestaurantPage = () => {

    const ParamRestaurantId = useParams();
    const { id } = ParamRestaurantId;

    // res
    const [aboutRes, setaboutRes] = useState([]);
    const { restaurants } = useContext(restaurantContext);

    let filterRes = [];

    useEffect(() => {
        restaurants.then(data => {
            data.filter(item => {
                if (item?.id == id) {
                    filterRes.push(item)
                    // console.log(filterRes)
                }
            })
        });

        setaboutRes(filterRes)
    }, [restaurants])

    return (
        <>
            <div className="custom-container">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    {
                        aboutRes.length == 0
                            ?
                            <div className="loader"></div>
                            :
                            aboutRes.map(item => {
                                return (
                                    <>
                                        <div key={item?.id} className="">
                                            <div className='card mb-2 restaurant-page-card'>
                                                <RestaurantCard fields={item?.fields} imgUrl={item?.fields?.restaurant_img} />
                                            </div>
                                        </div>
                                        <div className="">

                                            {/* gmaps embed */}
                                            {
                                                item?.fields['gmaps-link']
                                                    ?
                                                    <div className="card mb-2">
                                                        <iframe src={item?.fields['gmaps-link']} className="h-full w-full border" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                                    </div>
                                                    :
                                                    <></>
                                            }

                                            {/* review cards */}
                                            {(item?.fields?.review)?.map((eachReview, index) => {
                                                return (
                                                    <div className="card mb-2" key={index}>
                                                        <ReviewCard review={eachReview} reviewerName={item['fields']['reviewer-name'][index]} index={index} source={item['fields']['source'][index]} />
                                                    </div>
                                                )
                                            })}

                                            {/* delivery links */}
                                            {
                                                <>
                                                    <div className="grid grid-cols-2 gap-2">
                                                        {
                                                            item?.fields['swiggy-link']
                                                                ?
                                                                <button className="px-4 py-2 rounded bg-orange-600 text-white"><a href={item?.fields['swiggy-link']}>Swiggy</a></button>
                                                                :
                                                                <></>
                                                        }
                                                        {
                                                            item?.fields['zomato-link']
                                                                ?
                                                                <button className="px-4 py-2 rounded bg-red-600 text-white"><a href={item?.fields['zomato-link']}>Zomato</a></button>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </>
                                )
                            })
                    }
                </div>
            </div>
        </>
    )
}

export default RestaurantPage;